import gsap from 'gsap';
import debounce from 'lodash.debounce';

const SPEED = 0.7;

export default class Marquee {
  constructor(domElement) {
    this.dom = domElement;
    this.speed = SPEED;
    this.innerTop = this.dom.querySelector('.wrapper--top');
    this.originTop = this.dom.querySelector('.wrapper--top .group');
    this.innerBottom = this.dom.querySelector('.wrapper--bottom');
    this.originBottom = this.dom.querySelector('.wrapper--bottom .group');
    this.pos = 0;
    this.initialWindowWidth = window.innerWidth;

    this.init();
  }

  init() {
    gsap.set([this.innerTop, this.innerBottom], { force3D: true });

    this.addClones();

    window.addEventListener(
      'resize',
      debounce(() => this.resize(), 500),
      { passive: true },
    );

    this.updatePos = this.updatePos.bind(this);
    this.tick = requestAnimationFrame(this.updatePos);
  }

  resize() {
    // window 'resize' event gets called randomly on iOS
    // https://stackoverflow.com/questions/8898412/iphone-ipad-triggering-unexpected-resize-events
    if (this.initialWindowWidth !== window.innerWidth) {
      this.windowWidth = window.innerWidth;
      this.removeClones();
      this.addClones();
    }
  }

  addClones() {
    // if the marquee group is smaller than window width, clone it until it can fill the a window's width
    // otherwise clone it once
    this.createClone();
    for (
      let c = this.originTop.offsetWidth;
      c < window.innerWidth + this.getOffset();
      c += this.originTop.offsetWidth
    ) {
      this.createClone();
    }
  }

  createClone() {
    let clone = this.originTop.cloneNode(true);
    clone.classList.add('clone');
    this.innerTop.appendChild(clone);

    clone = this.originBottom.cloneNode(true);
    clone.classList.add('clone');
    this.innerBottom.appendChild(clone);
  }

  removeClones() {
    this.dom.querySelectorAll('.clone').forEach(e => {
      e.remove();
    });
  }

  getChildWidth() {
    return this.dom.querySelector('.img__container').offsetWidth;
  }

  getOffset() {
    return this.getChildWidth() * 1; // create a loop offset for rotation white space
  }

  updatePos() {
    this.tick = requestAnimationFrame(this.updatePos);

    this.pos += this.speed / (window.innerWidth / this.getChildWidth());
    if (this.pos >= this.dom.querySelector('.group').offsetWidth + this.getOffset()) {
      this.pos = this.getOffset();
    }
    gsap.set(this.innerTop, { x: -this.pos });
    gsap.set(this.innerBottom, {
      x: this.pos - this.dom.querySelector('.group').offsetWidth - this.getOffset(),
    });
  }
}
